module.exports = __webpack_public_path__ + "static/media/alexa_logo.2f105010.svg";